import React from "react";
import PropTypes from "prop-types";
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";
import TrackMedia from "../library/TrackMedia";
import JukeboxPlayTrack from "./Global/JukeboxPlayTrack";
import { useSettings } from "~/Context/SettingsContext";
import useReplaceHref from "~/utils/useReplaceHref";

const TrackMediaComment = (props) => {
  const { track, layout } = props;
  const { settings } = useSettings();
  useReplaceHref();

  function createTrackComment(track) {
    if (typeof track.comment !== "object") {
      return { __html: track.comment };
    } else {
      return track.comment;
    }
  }
  // must have a media_id to play in jukebox, this will exclude bandcamp, spotify
  // if any url in sc_url it will embed it on the left
  return (
    <React.Fragment>
      <Row className={track.sc_url ? `row-with-media` : `row-no-media`}>
        <Col
          xs={12}
          sm={12}
          md={{ span: track.comment ? 6 : 8, offset: track.comment ? 0 : 2 }}
          xl={{ span: !track.comment ? 8 : 5, offset: !track.comment ? 2 : null }}
          className="col-text-center"
        >
          {track.media_id && settings.playInJukebox ? <JukeboxPlayTrack track={track} /> : <TrackMedia track={track} layout={layout} />}
        </Col>
        {track.comment && (
          <Col xs={12} sm={12} md={6} xl={track.sc_url ? 7 : 12} className="section-body-comment">
            {track.comment && <div className="body-comment" dangerouslySetInnerHTML={createTrackComment(track)} />}
          </Col>
        )}
      </Row>
    </React.Fragment>
  );
};

TrackMediaComment.propTypes = {
  track: PropTypes.object.isRequired,
};

export default TrackMediaComment;
